const rowSelection = (This) => {
  const info = This.info
  const rowKey = info.rowKey || 'id'
  return info.rowSelection !== null ? {
    selectedRowKeys: info.selectedRowKeys,
    getCheckboxProps: (record) => ({ 
      disabled: record.disabled
    }),
    onChange(selectedRowKeys) {
      info.selectedRowKeys = selectedRowKeys
    },
    onSelect(record, selected) {
      if (selected) info.selectedRows.push(record)
      else {
        const index = info.selectedRows.findIndex(val => val[rowKey] === record[rowKey])
        info.selectedRows.splice(index, 1)
      }
      This.$emit('select-change',{ rows: info.selectedRows, keys: info.selectedRowKeys })
    },
    onSelectAll(selected, selectedRows, changeRows) {
      if (selected) info.selectedRows = info.selectedRows.concat(changeRows)
      else {
        let selectedRows = JSON.parse(JSON.stringify(info.selectedRows))
        const indexs = []
        selectedRows.forEach((item, index) => {
          changeRows.forEach(val => item[rowKey] === val[rowKey] && indexs.push(index))
        })
        indexs.forEach(item => delete selectedRows[item])
        selectedRows = selectedRows.filter(item => item !== undefined)
        info.selectedRows = selectedRows
      }
      This.$emit('select-change',{ rows: info.selectedRows, keys: info.selectedRowKeys })
    }
  } : null
}

export default {
  rowSelection
}